import Instance from "../../../../Axios";

// New Actions for the app

const GetCredFuncionarioFormacaoByFormId = (id) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/funcionarios/formacao/${id}`)
    .then(({ data }) => {
      dispatch({ type: "GET_CRED_FUNCIONARIO_FORMACAO_BY_FORM_ID", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredFuncionarioFormacaoByFormId;